import { SectionContainer } from "../molecules/section-container";
import { RectangleList } from "../molecules/reactangle-container-list";
import { useEffect, useState } from "react";
import { Button } from "../atoms/button";
import { useNavigate } from "react-router-dom";
import { PayoutStatus, usePayouts } from "../../providers/payout-provider";
import { useAuth } from "../../auth/AuthContext";
import { ErrorAlert } from "../atoms/error-alert";
import { getUserFriendlyPayoutError, renderErrorMessageWithLink } from "../../utils/payout-error-messages";

const formatLocalDate = (dateString: string | null | undefined) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

export const PaymentHistory = () => {
  const auth = useAuth() as { id: string | null; user: any } | null;
  const { fetchPayoutData, payoutData } = usePayouts();

  useEffect(() => {
    if (auth?.user) {
      fetchPayoutData(auth?.user?.accessToken)
        .then()
        .catch(() => navigate("/"));
    }
  }, [auth?.user]);

  const navigate = useNavigate();

  return (
    <>
      <SectionContainer title="Perle Collect - Payment History">
        <ErrorAlert message={renderErrorMessageWithLink(getUserFriendlyPayoutError(payoutData?.payout_error_message))} />
        <p className="mb-4 text-left">
          Payments are sent automatically after all your tasks are reviewed by
          QA and included on next payout run. Please note that rejected tasks
          will not be paid.
        </p>

        <div className="flex flex-col rounded-xl border-dark-gray border-2 flex p-4 mb-4 text-left">
          <h4>Approved Balance</h4>
          <span className="font-light mb-1">
            Tasks that passed QA and are ready for payment
          </span>
          <span className="text-[2em] font-bold text-progress-ok">
            $ {payoutData.total_approved}
          </span>
        </div>

        <div className="flex flex-col rounded-xl border-dark-gray border-2 flex text-left p-4 mb-6">
          <h4>Earnings in Review</h4>
          <span className="font-light mb-1">
            Tasks completed but still awaiting QA review
          </span>
          <span className="text-[2em] font-bold text-gray-500">
            $ {payoutData.total_in_review}
          </span>
        </div>
        {payoutData.history.filter((item) => item.status === "COMPLETED")
          .length > 0 && <h3 className="text-left mb-4">Payment History</h3>}
        <RectangleList
          items={payoutData.history
            .filter((item) => item.status === "COMPLETED")
            .map((historyItem) => (
              <div className="flex justify-between items-center">
                <div className="text-left">
                  <h3 className="text-left">Payment Id: {historyItem.id}</h3>
                  <div className="text-sm text-dark-gray-1 font-bold">
                    {formatLocalDate(historyItem.completed_at)}
                  </div>
                </div>
                <span className="overflow-visible grow text-right min-w-[20%]">
                  $ {historyItem.amount}
                </span>
              </div>
            ))}
        />
        <div className="mt-6 mb-4">
          <Button
            type="primary"
            text="Go to task selection"
            onClick={() => navigate("/")}
          />
        </div>
      </SectionContainer>
    </>
  );
};
